// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d981141b","186":"bc772950","272":"cc485cce","372":"f7d19821","377":"5f61bd7e","738":"3be71279","841":"ad7e42b4","851":"969e116f","856":"acc083be"}[chunkId] + ".chunk.js";
};